import { quickReplyMedia } from "../../features/quick-replies/models/quickReplyMedia";
import { canonicalMediaKind } from "./canonicalMedia";

export function slashSnippetQuery(draft) {
  return /^\/[^\s]*$/.test(draft) ? draft.slice(1).toLowerCase() : null;
}
export function matchingSnippets(items, query) {
  return items.filter(item => String(item.title || "").replace(/\s+/g, "").toLowerCase().includes(query));
}
const MIME_BY_EXTENSION = {
  jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", mp4: "video/mp4", m4v: "video/x-m4v", "3gp": "video/3gpp",
  aac: "audio/aac", m4a: "audio/mp4", mp3: "audio/mpeg", amr: "audio/amr", ogg: "audio/ogg", opus: "audio/opus",
  pdf: "application/pdf", doc: "application/msword", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint", pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation", txt: "text/plain",
};

export function snippetAttachments(item) {
  const attachments = [...(item.attachment ? [item.attachment] : []), ...(Array.isArray(item.attachments) ? item.attachments : [])];
  return attachments.filter((attachment, index) => !attachment.id || attachments.findIndex(other => other.id === attachment.id) === index);
}

export async function prepareCanonicalSnippet(item, channelAccountId) {
  const body = typeof item.body === "string" ? item.body : "";
  const files = await Promise.all(snippetAttachments(item).map(async attachment => {
    const download = (async () => {
      const cached = await quickReplyMedia.get(item.id, attachment.id, channelAccountId);
      const { blob } = cached;
      const name = attachment.file_name || "quick-reply";
      const receivedType = blob.type?.split(";", 1)[0];
      const type = attachment.mime_type || (receivedType && receivedType !== "application/octet-stream" ? receivedType : MIME_BY_EXTENSION[name.split(".").pop().toLowerCase()]) || "";
      const file = cached.file || new File([blob], name, { type });
      canonicalMediaKind(file); // Fail the entire selection rather than silently dropping media.
      cached.file = file;
      return file;
    })();
    return download;
  }));
  return { body, files };
}
